import { HttpError, requestJson } from '../../../shared/api/http'
import type { AuthSessionResponse, AuthUser, LoginInput } from '../model/contracts'

export async function fetchCurrentUser(signal?: AbortSignal): Promise<AuthUser | null> {
  try {
    const response = await requestJson<AuthSessionResponse>('/api/v1/auth/me', {
      method: 'GET',
      signal,
    })
    return response.user
  } catch (error) {
    if (error instanceof HttpError && error.status === 401) {
      return null
    }
    throw error
  }
}

export async function login(input: LoginInput): Promise<AuthUser> {
  const response = await requestJson<AuthSessionResponse>('/api/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify(input),
  })
  return response.user
}

export async function logout(): Promise<void> {
  await requestJson<null>('/api/v1/auth/logout', {
    method: 'POST',
  })
}
